import fetch from 'services/request';
import { IAddManUalGiftCardBody, IGetGiftCardDetail, IGetListGiftCard, IGetListRedeemTracking, IUpdateGiftCardBody } from './types/api';

const baseURL = 'api/v1/gift-card';

export const getListGiftCard = (params: IGetListGiftCard) => {
  return fetch({
    method: 'get',
    url: `${baseURL}/list`,
    params,
  });
};
export const getGiftCardDetail = (params: IGetGiftCardDetail) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/detail/${params.id}`,
  });
};

export const resetGiftCardDetail = (body: string[]) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/reset`,
    body,
  });
};

export const getSummaryGiftCards = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/gift-card/summary',
  });
};
const addManualGiftCard = (body: IAddManUalGiftCardBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/gift-card/add-manual',
    body,
  });
};

export const deleteGiftCard = (id: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/gift-card/delete/${id}`,
  });
};

export const resendGiftCard = (giftCardId: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/gift-card/resend-email-sms/${giftCardId}`,
  });
};

export const getRedeemTracking = (params: IGetListRedeemTracking) => {
  return fetch({
    method: 'get',
    url: '/api/v1/gift-card/list-tracking',
    params,
  });
};

export const updateGiftCard = (body: IUpdateGiftCardBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/gift-card/update',
    body,
  });
};

export const clearGiftCard = (giftCardId: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/gift-card/clear-history/${giftCardId}`,
  });
};

const giftCardsApis = {
  getListGiftCard,
  getGiftCardDetail,
  resetGiftCardDetail,
  getSummaryGiftCards,
  addManualGiftCard,
  deleteGiftCard,
  resendGiftCard,
  getRedeemTracking,
  updateGiftCard,
  clearGiftCard,
};

export default giftCardsApis;
